import { locales } from "@/i18n/locales";
import exactRedirects from "./legacy-redirects.json";

const exact = exactRedirects as Record<string, string>;

const KEEP = new Set(["/open-app.html", "/open-app"]);

const DISEASE_ALIASES: Record<string, string> = {
  bof: "/nl/blog/bof/",
  "buiktyfus-salmonella-type-ii": "buiktyfus",
  cholera: "/nl/travel/diseases/",
  "hepatitis-a-b": "hepatitis-a",
  influenza: "/nl/blog/influenza/",
  "malaria-type-profylaxe": "malaria",
  meningitis: "meningokokken",
  "rode-hond": "/nl/blog/rode-hond/",
  tetanus: "dtp",
  "tickborne-encefalitis": "tekenencefalitis",
  "tubercolose-tbc": "tuberculose",
};

export function normalizePathname(pathname: string): string {
  if (!pathname || pathname === "/") return "/";
  const noQuery = pathname.split("?")[0] ?? pathname;
  const withSlash = noQuery.startsWith("/") ? noQuery : `/${noQuery}`;
  if (withSlash.length > 1 && withSlash.endsWith("/")) {
    return withSlash.slice(0, -1);
  }
  return withSlash;
}

function localePrefixed(pathname: string): boolean {
  const first = pathname.split("/").filter(Boolean)[0];
  return Boolean(first && (locales as readonly string[]).includes(first));
}

function infectieZiekteTarget(slug: string): string {
  const mapped = DISEASE_ALIASES[slug] ?? slug;
  if (mapped.startsWith("/")) return mapped;
  return `/nl/travel/diseases/${mapped}/`;
}

function landVaccinatieTarget(slug: string): string {
  return `/nl/travel/${slug}/`;
}

/** Old vaxy.app / Laravel / app URLs → new `/{locale}/.../` paths. */
export function resolveLegacyPath(pathname: string): string | null {
  const path = normalizePathname(pathname);
  if (path === "/" || KEEP.has(path) || path.startsWith("/.well-known")) {
    return null;
  }
  if (localePrefixed(path)) return null;

  const hit = exact[path];
  if (hit) return hit;

  const land = path.match(/^\/land\/vaccinatie\/([^/]+)(?:\/\d+)?$/);
  if (land?.[1]) return landVaccinatieTarget(land[1]);

  const disease = path.match(/^\/infectie-ziekte\/([^/]+)(?:\/\d+)?$/);
  if (disease?.[1]) return infectieZiekteTarget(disease[1]);

  if (
    path.startsWith("/vaccinatie-nieuws/") ||
    path.startsWith("/rijksvaccinaties/") ||
    path.startsWith("/vaccinatie/") ||
    path.startsWith("/category/") ||
    path.startsWith("/tag/")
  ) {
    return "/nl/blog/";
  }

  if (path.startsWith("/careers/") || path.startsWith("/career/")) {
    return "/nl/contact/";
  }

  if (path.startsWith("/author/")) return "/nl/about/";

  return null;
}
